// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthorCard-module--root--3e9gr","profile":"AuthorCard-module--profile--3AlP_","text":"AuthorCard-module--text--30EDp"};